import Box from "@mui/material/Box";
import type { PropsWithChildren } from "react";

export default function PublicLayout({ children }: PropsWithChildren) {
    return <Box sx={{ minHeight: "100vh" }}>{children}</Box>;
}
